/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-03-22 21:34:00
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2025-07-22 13:50:22
 */
/** 不显示面包屑的路由 */
export const BREADCRUMB_INACTIVE_ROUTE = [
  'ModeVew',
  'WorkbenchView',
  'DesignView',
  'SelectProductView',
  'KnowledgeBaseView',
]

// 不显示侧边栏的路由名称
export const SIDEBAR_INACTIVE_ROUTE = [
  // 'HomeView',
  // 'WorkbenchView',
  'CreateProductView',
  'ProductDetailMainView',
  'ProductDetailView',
  'ProposalDetailView',
  'ProductInformationView',
  'ProductIntelligenceView',
  'ProductDynamicView',
  'PersonalCenterView',
  'PersonalCenterBasicInfoView',
  'PersonalCenterEnergyPointInfoView',
  'PersonalCenterExchangeEnergyPointView',
  'PersonalCenterCompanyManagementView',
  'PersonalCenterCompanyProductMembersView',
  'KnowledgeFileDetail',
  'ProductProcessSolutionIntroduction',
  'InspirationLibraryDetail',
  'NoWorkspaceView',
  'NotifyView',
  'ModeView',
  'MarketAgentReport',
  'CustomerProposalDetail',
  'CustomerProposalArchive',
  'CustomerProposalPpt',
  'SquareProposalDetail',
]
